import { render, staticRenderFns } from "./luckdrawdetails_new.vue?vue&type=template&id=a4715c8c&scoped=true&"
import script from "./luckdrawdetails_new.vue?vue&type=script&lang=js&"
export * from "./luckdrawdetails_new.vue?vue&type=script&lang=js&"
import style0 from "./luckdrawdetails_new.vue?vue&type=style&index=0&id=a4715c8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4715c8c",
  null
  
)

export default component.exports